/**
 * ReadyBulkBar — sticky Bulk-Freigabe-Leiste im „Bereit"-Tab (T8). Ausgelagert
 * aus `ReadyBulkList.tsx` wegen des Component-Size-Limits.
 */
import { useTranslation } from 'react-i18next'

import { EID } from '@/lib/element-ids.registry'

export interface ReadyBulkBarProps {
  count: number
  gateOpen: boolean
  approving: boolean
  onApproveAll: () => void
}

export function ReadyBulkBar({ count, gateOpen, approving, onApproveAll }: ReadyBulkBarProps) {
  const { t } = useTranslation()
  return (
    <div className="sticky bottom-0 flex items-center gap-3 rounded-lg border border-neutral-200 bg-white/95 p-3 backdrop-blur dark:border-neutral-800 dark:bg-neutral-900/95">
      <button
        type="button"
        id={EID['text-bulk-ready-approve-all-btn']}
        disabled={!gateOpen || approving}
        onClick={onApproveAll}
        className="rounded-md bg-orange-600 px-4 py-2 text-sm font-semibold text-white hover:bg-orange-700 disabled:opacity-50"
      >
        {t('channelContent.ready.approveAll', { count })}
      </button>
      {!gateOpen && (
        <span className="text-xs text-neutral-500 dark:text-neutral-400">{t('channelContent.ready.approveAllHint')}</span>
      )}
    </div>
  )
}
